import { combineReducers } from 'redux'
import { reducer as reduxFormReducer } from 'redux-form'
import * as types from '../constants/ActionTypes'

import roumu from './roumu'
import auth from './auth'
import kenmeiList from './kenmeiList'
import common from './common'

import master from './master'
import yosan from './yosan'
import yosanList from './yosanList'
import yosanHistoryList from './yosanHistoryList'
import bizHoliday from './bizHoliday'
import subHoliday from './subHoliday'
import systemControll from './systemControll'

const globalInitialState = {
  load: false,
  snackbar: {
    open: false,
    message: '',
    color: ''
  }
}

const global = (state = globalInitialState, action) => {
  switch (action.type) {
    case types.REDUCER_APP_LOADING: 
      return Object.assign({}, state, action.payload)
    case types.REDUCER_SNACKBAR: 
      return Object.assign({}, state, action.payload)
    case types.REDUCER_ERROR_MESSAGE:
          return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

const initialState = {
}

const xxx = (state = initialState, action) => {
  switch (action.type) {
    case 'XXX':
      return state
    default:
      return state
  }
}

const reducers = combineReducers({
  xxx,
  roumu,
  global,
  auth,
  kenmeiList,
  common,
  master,
  yosan,
  yosanList,
  bizHoliday,
  subHoliday,
  systemControll,
  yosanHistoryList,
  form: reduxFormReducer
})

export default reducers


// WEBPACK FOOTER //
// ./src/reducers/index.js